export default "__VITE_ASSET__BCPIoV6R__"